import * as React from 'react';
import * as MuiCore from '@material-ui/core';

export type TextProps = MuiCore.TypographyProps & {};

export const Text: React.FC<TextProps> = (props) => (
  <MuiCore.Typography {...props} />
);
